// extracted by mini-css-extract-plugin
module.exports = {"custom-tag":"custom-tag___1o8LF","customTag":"custom-tag___1o8LF","close":"close___pIAn6"};